<template>
  <div class="product-template __donate  __limited-edu __uob-2026-template">
    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-8">
        <div class="text-center mb-10 wrap-logo">
          <img src="/static/img/uob/UOBxTCFE.png" srcset="/static/img/uob/UOBxTCFE.png" alt="UOB x TCFE" style="width: 310px" class="logo pd-15 ma-auto d-block" />
        </div>
        <h3 class="text-center mb-10">ทุก 200 บาท = 1 สิทธิ์ลุ้นรางวัลสุดพิเศษ</h3>
        <div class="text-center text-primary mb-20">ระดมทุนสนับสนุนการพัฒนาคุณภาพการศึกษา<br />และสร้างโอกาสทางการเรียนรู้ที่ยั่งยืน ในโครงการ UOB My Digital Space</div>
      </div>
    </div>
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10 col-lg-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form">
            <div class="radius block shadow">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />
              <div class="row">
                <div class="col-sm-12 col-md-6">
                    <!-- ตำแหน่ง -->
                    <div class="pt-15">
                        <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div>
                        <div class="form__select">
                            <!-- rewardConfigChoice (ตำแหน่ง) -->
                            <select v-model="attributes.info.rewardConfigChoice">
                                <option value="">-- โปรดระบุตำแหน่ง --</option>
                                <option
                                v-for="LevelOption in LevelOptions"
                                :key="LevelOption.text"
                                :value="LevelOption.description"
                                >
                                {{ LevelOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6">
                    <!-- หน่วยงาน -->
                    <div class="pt-15">
                        <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div>
                        <div class="form__select">
                            <!-- rewardConfigText (หน่วยงาน) -->
                            <select v-model="attributes.info.rewardConfigText">
                                <option value="">-- โปรดระบุหน่วยงาน --</option>
                                <option
                                v-for="FunctionOption in FunctionOptions"
                                :key="FunctionOption.text"
                                :value="FunctionOption.description"
                                >
                                {{ FunctionOption.description }}
                                </option>
                            </select>
                        </div>
                        <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                    </div>
                </div>
                <!-- รหัสพนักงาน -->
                <div class="col-sm-12 col-md-6">
                  <div class="pt-15">
                    <div><strong>รหัสพนักงาน <span style="color: #E82B27">*</span></strong></div>
                    <div class="">
                      <input
                        type="text"
                        class="form__select"
                        v-model="attributes.info.employeeId"
                        placeholder="กรอกรหัสพนักงาน 8 ตัว"
                        maxlength="8"
                        @input="validateEmployeeId"
                      />
                    </div>
                    <div class="alert alert--error" v-if="error.employeeId">{{ error.employeeIdMessage }}</div>
                  </div>
                </div>
              </div>
              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />
              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  export default {
    name: 'ProductTemplateUOBxLimitedEducation2024',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },
    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },
    data () {
      return {
        tshirtProductName: 'UOB 2026 Songkran Festival',
        attributes: {
          info: {
            name: '',
            employeeId: '',
            rewardConfigChoice: '',
            rewardConfigText: ''
          },
          page: ''
        },
        error: {
          employeeId: false,
          employeeIdMessage: '',
          rewardConfigChoice: false,
          rewardConfigText: false
        }
      }
    },
    computed: {
      // ตำแหน่ง
      LevelOptions () {
        // 1:Managing Director,2:Executive Director
        return this.product.meta.donation_level_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // หน่วยงาน
      FunctionOptions () {
        // 1:Personal Financial Services, 2:Project Management Office
        return this.product.meta.donation_function_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      }
    },
    methods: {
      validateEmployeeId () {
        const employeeId = this.attributes.info.employeeId
        const alphanumericRegex = /^[A-Za-z0-9]+$/

        if (!employeeId) {
          this.error.employeeId = false
          this.error.employeeIdMessage = ''
        } else if (employeeId.length !== 8) {
          this.error.employeeId = true
          this.error.employeeIdMessage = 'รหัสพนักงานต้องมี 8 ตัวอักษร'
        } else if (!alphanumericRegex.test(employeeId)) {
          this.error.employeeId = true
          this.error.employeeIdMessage = 'รหัสพนักงานต้องประกอบด้วยตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น'
        } else {
          this.error.employeeId = false
          this.error.employeeIdMessage = ''
        }
      },
      validate () {
        this.error.employeeId = false
        this.error.employeeIdMessage = ''
        this.error.rewardConfigChoice = false
        this.error.rewardConfigText = false
        this.error.name = false
        let valid = true
        const {info} = this.attributes

        // Validate employee ID
        if (!info.employeeId) {
          this.error.employeeId = true
          this.error.employeeIdMessage = 'กรุณากรอกรหัสพนักงาน'
          valid = false
        } else if (info.employeeId.length !== 8) {
          this.error.employeeId = true
          this.error.employeeIdMessage = 'รหัสพนักงานต้องมี 8 ตัวอักษร'
          valid = false
        } else if (!/^[A-Za-z0-9]+$/.test(info.employeeId)) {
          this.error.employeeId = true
          this.error.employeeIdMessage = 'รหัสพนักงานต้องประกอบด้วยตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น'
          valid = false
        }

        // Validate position
        if (!info.rewardConfigChoice) {
          this.error.rewardConfigChoice = true
          valid = false
        }

        // Validate function/department
        if (!info.rewardConfigText) {
          this.error.rewardConfigText = true
          valid = false
        }

        return valid
      },
      async donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }
        if (!this.validate()) {
          return
        }
        if (this.product.meta.receipt_item_description) {
          this.attributes.info._receiptItemDescription = this.product.meta.receipt_item_description
        }
        // Clear previous cart info.
        await this.$store.dispatch('clearCart')
        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .__uob-2026-template {
    background: #ebebeb !important;
  }
  h1.page-title {
    color: #015eb8;
    font-size: 2em;
    font-weight: 500;
    margin-bottom: 15px;
  }
  h3 {
    color:#015eb8;
  }
  .text-primary {
    color: #015eb8;
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }

</style>



// WEBPACK FOOTER //
// uob-songkran-fastival-2026.vue?6eb5e780